

export const notes = {
    "default1": "ECG Interpreted by ECG Expert is the primary diagnosis of cardiovascular health. The Spandan ECG experts interprets the ECG reports based on the Theories and principles of Electrocardiography. CoS- relate the interpretation with symptoms and do consult your physician for a detailed diagnosis. This is Electronically authenticated report, hence doesn't require signature. Software calculated values to be verified manually.",
    "default": "Medical advice asked and accepted on the internet (without physically examining the patient) is at patient’s own risk. Visit a doctor in case of emergency."
};

export const signatures_offline = [
    // {   
    //     name: "Abhishek Sahu",
    //     value: "abhishek-sahu.png",
    //     phoneNumber: "+917055044556"
    // },
    {
        name: "Gourav Ojha",
        value: "gourav-ojha.png",
        phoneNumber: "+917055011556"
    },
    {   
        name: "Muskan Agrahari",
        value: "muskan-agrahari.png",
        phoneNumber: "+918650015556" 
    },
    {   
        name: "Pankaj Singh Rana",
        value: "pankaj-singh-rana.png",
        phoneNumber: "+918394005353"
    },
    // {
    //     name: "Vetrivel Senthilvadivel",
    //     value: "vetrivel-senthilvadivel.png",
    //     phoneNumber: "+917055051119"
    // },
    { 
        name: "Dr. Christianez Ratna",
        value: "dr-christianez-ratna.png",
        phoneNumber: "+911234566666",
        default: true,
    },
    //  {
    //     name: "Yogendra",
    //     value: "dr-yogendra.png",
    //     phoneNumber: "+917055011556"
    // },
       { 
        name: "Khushal Saini",
        value: "khushal-saini.png",
        phoneNumber: "+917015887767",
        
    },
     { 
        name: "Astha Singh",
        value: "astha-singh.png",
        phoneNumber: "+918299745911",
       
    },
];

export const signatures_live = [
    // {   
    //     name: "Abhishek Sahu",
    //     value: "abhishek-sahu.png",
    //     phoneNumber: "+917055044556"
    // },
    {
        name: "Gourav Ojha",
        value: "gourav-ojha.png",
        phoneNumber: "+917055011556"
    },
    {   
        name: "Muskan Agrahari",
        value: "muskan-agrahari.png",
        phoneNumber: "+918650015556"
    },
    {   
        name: "Pankaj Singh Rana",
        value: "pankaj-singh-rana.png",
        phoneNumber: "+918394005353"
    },
    // {
    //     name: "Vetrivel Senthilvadivel",
    //     value: "vetrivel-senthilvadivel.png",
    //     phoneNumber: "+917055051119"
    // },
    { 
        name: "Dr. Christianez Ratna",
        value: "dr-christianez-ratna.png",
        phoneNumber: "+911234566666",
        default: true,
    },
    //   {
    //     name: "Yogendra",
    //     value: "dr-yogendra.png",
    //     phoneNumber: "+917055011556"
    // },
    { 
        name: "Khushal Saini",
        value: "khushal-saini.png",
        phoneNumber: "+917015887767",
        
    },
     { 
        name: "Astha Singh",
        value: "astha-singh.png",
        phoneNumber: "+918299745911",
       
    },
];
export const BASE_URL = `${process.env.REACT_APP_API_KEY}`

